import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bubble } from "react-chartjs-2";
import Export from "../../assets/dashboard/export.svg";
import tabImg from "../../assets/dashboard/tabImg.svg";
import chart from "../../assets/dashboard/chart.png";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend
);

const EmergingKeyword = () => {
  const [activeTab, setActiveTab] = useState("Top content");

  const tabs = [
    { label: "Top content", icon: tabImg },
    { label: "Trending", icon: tabImg },
  ];

  const data = {
    datasets: [
      {
        label: "Higher engagement",
        data: Array.from({ length: 25 }, () => ({
          x: Math.floor(Math.random() * 200 - 100),
          y: Math.floor(Math.random() * 200 - 100),
          r: Math.floor(Math.random() * 15 + 5),
        })),
        backgroundColor: "#fdd835",
      },
      {
        label: "Lower engagement",
        data: Array.from({ length: 25 }, () => ({
          x: Math.floor(Math.random() * 200 - 100),
          y: Math.floor(Math.random() * 200 - 100),
          r: Math.floor(Math.random() * 15 + 5),
        })),
        backgroundColor: "#55dde0",
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: true,
          boxWidth: 12,
        },
      },
    },
    scales: {
      x: {
        min: -100,
        max: 100,
        grid: {
          color: "#e5e5e5",
        },
      },
      y: {
        min: -100,
        max: 100,
        grid: {
          color: "#e5e5e5",
        },
      },
    },
  };

  return (
    <div className="border border-gradient-04 rounded-2xl p-2 md:p-4 shadow-sm bg-white">
      {/* Header */}
      <div className="flex justify-between items-center mb-4 border-b border-black-40">
        <h2 className="font-bold text-lg text-black-800 uppercase">
          Emerging Keywords
        </h2>
        <button className="p-3 mb-2 bg-black-0 hover:bg-black-20 focus:bg-black-40 border-2 border-black-600 rounded group relative">
          <img src={Export} alt="Export" />
          <div className="absolute top-12 left-1/2 -translate-x-1/2 mr-2 px-2 py-1 bg-gray-800 text-white text-xs shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 whitespace-nowrap uppercase">
            Export
            <div className="absolute left-1/2 bottom-full border-4 border-transparent border-b-gray-800"></div>
          </div>
        </button>
      </div>

      {/* Tabs */}
      <div className="flex justify-center">
        <div className="flex gap-4 mb-4 bg-black-30 border-2 border-black-30 rounded-md items-center justify-center">
          {tabs.map(({ label, icon }) => (
            <button
              key={label}
              onClick={() => setActiveTab(label)}
              className={`flex items-center justify-center gap-2 pb-2 p-4 text-lg ${
                activeTab === label ? "bg-black-0 rounded-md" : ""
              }`}
            >
              <img src={icon} alt={label} className="w-6 h-6" />
              {label}
            </button>
          ))}
        </div>
      </div>

      {/* Description */}
      <p className="text-lg text-black-800 mb-2">
        Below, we present some of the most relevant posts today. You can filter
        by keyword, or search by keyword to find the top 10 trends on Linkedin.
      </p>

      {/* Filters */}
      <div className="space-y-4 mb-4">
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Industry
          </label>
          <select className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-50 focus:outline-none cursor-pointer">
            <option>Select</option>
          </select>
        </div>
        <div>
          <label className="block text-lg font-bold text-black-800 mb-1">
            Keyword
          </label>
          <input
            type="text"
            placeholder="Write the keyword"
            className="w-full h-[42px] border border-black-600 rounded px-3 py-2 text-lg text-black-600 placeholder:text-black-50 focus:outline-none"
          />
        </div>
      </div>

      {/* Bubble Chart */}
      {/* <Bubble data={data} options={options} /> */}
      <img src={chart} alt="chart" />
    </div>
  );
};

export default EmergingKeyword;
